import { SvgIconsEnums } from "@ilg-credability/credability-web-components";
import { UtmParameters } from "@ilg-core/inscalar-web";
import { useEffect, useState } from "react";

const uatDomain = "credability-test.co.uk";
const localhostDomain = "localhost";

const isExactHostOrSubdomain = (hostname: string, domain: string): boolean =>
  hostname === domain || hostname.endsWith(`.${domain}`);

const isExactHost = (hostname: string, domain: string): boolean =>
  hostname === domain;

export const isProductionEnv = (): boolean => {
  if (typeof window === "undefined") return false;
  const hostname = window.location.hostname;
  return (
    !isExactHostOrSubdomain(hostname, uatDomain) &&
    !isExactHost(hostname, localhostDomain)
  );
};

export const isLocalEnv = (): boolean => {
  if (typeof window === "undefined") return false;
  return isExactHost(window.location.hostname, localhostDomain);
};

export const nthNumber = (number: number) => {
  switch (number % 10) {
    case 1:
      return `${number}st`;
    case 2:
      return `${number}nd`;
    case 3:
      return `${number}rd`;
    default:
      return `${number}th`;
  }
};

const MAX_MOBILE_WIDTH = 768;

export const useWindowDimensions = () => {
  const [width, setWidth] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const update = () => {
      setWidth(window.innerWidth);
      setIsMobile(window.innerWidth < MAX_MOBILE_WIDTH);
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  return { width, isMobile };
};

export const getCategoryIcon = (category: string) => {
  const categoryIcons: Record<string, SvgIconsEnums> = {
    'Home': SvgIconsEnums.MORTGAGES,
    'Wrench': SvgIconsEnums.WRENCH,
    'Award': SvgIconsEnums.AWARD,
    'Loan': SvgIconsEnums.LOAN,
    'Mortgage': SvgIconsEnums.SECURED_LOANS,
    'Lightbulb': SvgIconsEnums.LIGHT_BULB,
    'Calendar': SvgIconsEnums.CALENDAR,
    'Search': SvgIconsEnums.REPORT_SEARCH,
    'Card': SvgIconsEnums.CREDIT_CARD,
    'Default': SvgIconsEnums.INFO_CIRCLE,
  };

  return categoryIcons[category] || categoryIcons.Default;
};

export const getColorClass = (color: string) => {
  if (color === 'var(--cred-color-light-primary)') return 'purple';
  if (color === '#F27500') return 'orange';
  if (color === '#4CAF50') return 'green';
  return '';
};

export async function retryOnce<T>(fn: () => Promise<T>): Promise<T> {
  try {
    return await fn();
  } catch {
    return fn();
  }
}

export const getUtmsParams = (): UtmParameters => {
  const params: { key: string; value: string }[] = JSON.parse(
    window.sessionStorage.getItem("urlParams") ?? "[]"
  );
  const keyMap: Record<string, keyof UtmParameters> = {
    utm_source: "utmSource",
    utm_medium: "utmMedium",
    utm_campaign: "utmCampaign",
    utm_term: "utmTerm",
    utm_content: "utmContent",
  };
  const utms: UtmParameters = {};
  params.forEach((param) => {
    const mapped = keyMap[param.key];
    if (mapped) {
      utms[mapped] = param.value;
    }
  });

  return utms;
}
